import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable'
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from '@mui/material';
// import BannerinputGetModal from '../../../CommonModal/BannerModal/BannerinputGetModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import '../../../../Components/ModalCss/BannerinputGetModal.css';
// import LandingPage from '../../Preview/LandingPage';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import BannerinputGetModal from '../Modal/Banner/BannerinputGetModal';
import AboutUsMainPage from '../AboutUsPreview/Banner/AboutUsMainPage';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
// import ReferralsMainPage from '../ReferralsContentPreview/Banner/ReferralsMainPage';

const BannerSection = () => {

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Title', 'Second Text', 'Sub Text', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "status"]
        : ['S.No', 'Title', 'Second Text', 'Sub Text', 'status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getAboutUsSectionById } = useSelector(state => state?.getAboutUsSectionById);
    const { addAboutUsSection } = useSelector(state => state?.addAboutUsSection);

    const { updateAboutUsSection } = useSelector(
        (state) => state?.updateAboutUsSection
    );

    const { deleteAboutUsSection } = useSelector(
        (state) => state?.deleteAboutUsSection
    );




    const { getAllAboutUsSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllAboutUsSectionsWithCreatorBySectionName
    );

    const { getAllAboutUsSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllAboutUsSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllAboutUsSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addAboutUsSectionWithApproval } = useSelector(
        (state) => state?.addAboutUsSectionWithApproval
    );



    
      useEffect(() => {
        dispatch(setHeaderName("Content Management"));
        dispatch(setSubHeaderName("About Us"));
      }, []);
      

    const { updateAboutUsSectionForReApproval } = useSelector(
        (state) => state?.updateAboutUsSectionForReApproval
    );


    const { approveAboutUsSection } = useSelector((state) => state?.approveAboutUsSection);
    const { rejectAboutUsSection } = useSelector((state) => state?.rejectAboutUsSection);



    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "banner" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllAboutUsSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLABOUTUSSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "banner" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllAboutUsSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLABOUTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)


            }
        }


        fetchData();
    }, [addAboutUsSection, approveAboutUsSection, rejectAboutUsSection, addAboutUsSectionWithApproval, deleteAboutUsSection, updateAboutUsSection, updateAboutUsSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllAboutUsSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllAboutUsSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllAboutUsSectionsBySectionNameBasedOnCreator, getAllAboutUsSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")


    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteAboutUsSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETEABOUTUSSECTION(data1));
        if (responseData?.payload?.message === "About Us section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }



    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>

                <CustomTable
                    // tableEdit="tableEdit"
                    // tableDelete="tableDelete"
                    sectionNameForApproveAndReject="AboutUsSection"
                    tableData={rowTableData} title="Banner" tableHeadData={tableHeadData}
                    //   modalName={BannerinputGetModal}
                    //   editModalName={BannerinputGetModal}


                    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
                    tableView={true}
                    modalVeiwName={PreviewComponent}
                    ModalPreviewComponent1={AboutUsMainPage}

                    handleTableDataDelete={handleTableDataDelete}


                    tableDelete={permissions?.ContentManagement?.["About Us"]?.delete}
                    tableEdit={permissions?.ContentManagement?.["About Us"]?.edit}
                    dataCreate={permissions?.ContentManagement?.["About Us"]?.add}
                    //   apiBasedName="stakeNowBannerInputModal"
                    //   tableData={rowTableData}
                    //   title="Banner"
                    //   tableHeadData={tableHeadData}
                    modalName={BannerinputGetModal}
                    editModalName={BannerinputGetModal}
                //   handleTableDataDelete={handleTableDataDelete}

                />

            </Grid>
        </Grid>
    )
}

export default BannerSection